module.exports = __webpack_public_path__ + "static/media/image_6.2762b15c.jpg";